<template>
  <div class="c-table" ref="designerDetailTable">
    <!-- <Spin size="large" fix v-if="loading" /> -->
    <el-table
      class="common-el-table-styles summary-el-table-styles"
      ref="table"
      border
      stripe
      show-summary
      v-loading="loading"
      height="100%"
      :data="data"
      :summary-method="summary"
    >
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <Poptip confirm transfer title="您确认删除该数据吗？" @on-ok="$emit('on-del', scope.row)">
              <el-button type="text" size="small">删除</el-button>
            </Poptip>
          </div>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
      <template slot="empty">
        <no-data />
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'designerDetailTable',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array
    },
    summary: {
      type: Function
    }
  },
  methods: {
    doLayout() {
      this.$refs.table.doLayout()
    }
  }
}
</script>

<style lang="scss" scoped>
.c-table {
  height: calc(100% - 40px);
}
</style>
